import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'
import TextareaField from 'Pods/Shared/TextareaField'
import InputField from 'Pods/Shared/InputField'
import { required } from 'Pods/Shared/Rules/Rules'
import { RuleRunner, run } from 'Pods/Shared/RuleRunner'

const fieldValidations = [
  RuleRunner('subject', 'Subject', required),
  RuleRunner('message', 'Message', required),
]

class ContactModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isDisabledSubmit: this.props.messagingForbidden,
      subject: this.props.galleryTitle ? `Request to Purchase 3D Model: ${this.props.galleryTitle}` : '',
      message: '',
      showErrors: false,
    }

    this.onModalClose = this.onModalClose.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
  }

  componentWillMount() {
    this.setState({ validationErrors: run(this.state, fieldValidations) })
  }

  sendMessage(e) {
    e.preventDefault()

    this.setState({ isDisabledSubmit: true, showErrors: true })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
      axios.post(
        '/api/internal/conversations',
        {
          conversation: {
            subject: this.state.subject,
            message: this.state.message,
            item_id: this.props.itemId,
            gallery_id: this.props.galleryId,
            recipient: this.props.authorUsername,
            conversation_type: this.props.conversationType,
          },
        }
      ).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
    } else {
      this.setState({ isDisabledSubmit: false })
    }
  }

  onSubmitSuccess() {
    this.setState({ isDisabledSubmit: false, subject: '', message: '' })
    App.events.publish('app:notification:flash:success', I18n.t('model.support_form.message_sent'))
    this.props.closeModal()
  }

  onSubmitFailure(xhr) {
    let message = xhr.response.data.errors[0].detail?.message || 'Something went wrong, please try again'

    App.events.publish('app:notification:flash:error', message)

    this.setState({ isDisabledSubmit: false })
  }

  onModalClose(e) {
    this.setState({ isDisabledSubmit: false })
    this.props.closeModal(e)
  }

  handleInputChange(e) {
    const newState = this.state

    newState[e.target.name] = e.target.value
    newState.validationErrors = run(newState, fieldValidations)

    this.setState(newState)
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--product overlay-modal--jobs">
            <h2 className="heading-18">{this.props.headerText}</h2>
            {this.props.subtitle && (<h3 className="heading-16">{this.props.subtitle}</h3>)}
            <form onSubmit={(e) => this.sendMessage(e)}>
              <div className="form-group">
                {!this.props.galleryId && (
                  <InputField
                    label="Subject"
                    id="subject"
                    name="subject"
                    value={this.state.subject}
                    formClassName="form-group-grey"
                    inputClassName="form-control-grey"
                    onChange={this.handleInputChange}
                    placeholder="Type here..."
                    errorText={this.errorFor('subject')}
                    showError={this.state.showErrors}
                    disabled={this.props.messagingForbidden}
                  />
                )}
                <TextareaField
                  id="message"
                  name="message"
                  label="Message"
                  value={this.state.message}
                  formClassName="form-group-grey"
                  inputClassName="form-control-grey"
                  onChange={this.handleInputChange}
                  placeholder="Type here..."
                  errorText={this.errorFor('message')}
                  showError={this.state.showErrors}
                  disabled={this.props.messagingForbidden}
                />
              </div>
              {this.props.messagingForbidden && (
                <p className="text-red">
                  {I18n.t('users.suspended_messaging')}
                </p>
              )}

              <div className="footer u-text-right u-mt10">
                <button className="cgt-button cgt-button--secondary cgt-button--medium" onClick={this.onModalClose}>
                  <span>Cancel</span>
                </button>
                <button
                  type="submit"
                  className="cgt-button cgt-button--primary cgt-button--medium cgt-ml-10"
                  disabled={this.state.isDisabledSubmit}
                >
                  <span>Send message</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    )
  }
}

ContactModal.propTypes = {
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  authorUsername: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool,
  conversationType: PropTypes.string.isRequired,
  headerText: PropTypes.string,
  subtitle: PropTypes.string,
  galleryId: PropTypes.number,
  galleryTitle: PropTypes.string,
  messagingForbidden: PropTypes.bool,
}

ContactModal.defaultProps = {
  itemId: '',
  modalIsOpen: false,
  headerText: 'Message me',
  subtitle: null,
  galleryId: null,
  galleryTitle: null,
  messagingForbidden: false,
}

export default ContactModal
